import { ApplicationInsights } from "@microsoft/applicationinsights-web";

let appInsightsInstance: ApplicationInsights | null = null;

export const setAppInsightsInstance = (appInsights: ApplicationInsights) => {
  appInsightsInstance = appInsights;
};

export const trackAppInsightsEvent = (
  name: string,
  properties?: Record<string, string | number | boolean | null | undefined>
) => {
  appInsightsInstance?.trackEvent({ name }, properties);
};